import { isMyApp } from '@/utils/bridge'
import { toAppLogin } from '@/api/app'
import { handle401 as mini401, getIsMiniapp } from '@/utils/miniapp'
import authority from '@/utils/authority'

let timer

export function handle401() {
  authority.clear()
  if (isMyApp) {
    return toAppLogin()
  }
  if (getIsMiniapp()) {
    return mini401()
  }
  if (timer) return
  timer = setTimeout(() => {
    window.location.reload()
  }, 1000)
}
